import { createElement } from 'react'
import { createRoot } from 'react-dom/client'
import Modal from 'react-modal'
import RegistrationPage from './page/RegistrationPage'
import { LoginModal } from './components/LoginModal'
import LoginPage from './page/LoginPage'

const publicPages = {
  'user-registration': RegistrationPage,
  'user-login': LoginPage,
}

const getProps = (element) => {
  const propsElement = document.getElementById(element.dataset.reactPropsId)

  const props = propsElement ? JSON.parse(propsElement.textContent) : {}

  if (element.dataset.reactErrorMessage) {
    props.errorMessage = element.dataset.reactErrorMessage
  }

  return props
}

document.querySelectorAll('[data-react-public-root]').forEach((element) => {
  const Page = publicPages[element.dataset.reactPublicRoot]

  if (Page) {
    createRoot(element).render(createElement(Page, getProps(element)))
  }
})

const loginModalRoot = document.querySelector('[data-react-login-modal-root]')

if (loginModalRoot) {
  Modal.setAppElement(loginModalRoot)
  createRoot(loginModalRoot).render(
    createElement(LoginModal, getProps(loginModalRoot))
  )
}
